import { render, staticRenderFns } from "./partner_info.vue?vue&type=template&id=2e982314&scoped=true"
import script from "./partner_info.vue?vue&type=script&lang=js"
export * from "./partner_info.vue?vue&type=script&lang=js"
import style0 from "./partner_info.vue?vue&type=style&index=0&id=2e982314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e982314",
  null
  
)

export default component.exports